import Card from '@/components/primitives/Card.jsx';
import Select from '@/components/primitives/Select.jsx';
import useThemePreference from '@/lib/theme/useThemePreference.js';

const THEME_ITEMS = [
  { value: 'system', label: 'Match system' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' }
];

/** Light, dark or the system's choice, kept on this device. */
const AppearanceSection = () => {
  const [themePreference, setThemePreference] = useThemePreference();

  return (
    <Card title="Appearance" description="Applies on this device only.">
      <div className="settings-field">
        <Select label="Theme" items={THEME_ITEMS} value={themePreference} onValueChange={setThemePreference} />
      </div>
    </Card>
  );
};

export default AppearanceSection;
